// A tab left open across a deploy keeps running the bundle it loaded — the
// browser never refetches it on its own, so users silently exercise old code
// against a new API. `index.html` is served `no-cache` (see spa_cache_control),
// so a reload is all it takes; this just tells them a reload is due.
//
// The comparison is the build-time workspace version against the running
// server's — both read from the same `[workspace.package] version`, so they
// differ only after a deploy of a different build.

import { useHealth } from '@/lib/useHealth';
import { buttonVariants } from '@/components/ui/Button';

export function StaleBundleNotice() {
  const health = useHealth();
  const serverVersion = health.data?.version;
  if (!serverVersion || serverVersion === __APP_VERSION__) return null;

  return (
    <div className="flex items-center justify-center gap-3 bg-tres-action px-4 py-1.5 text-center text-xs font-medium text-white">
      <span>
        A newer version of TReS is running on the server ({serverVersion}); this tab is on{' '}
        {__APP_VERSION__}.
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className={buttonVariants({ variant: 'chrome', size: 'sm' })}
      >
        Reload
      </button>
    </div>
  );
}
